export const ATTENDANCE_TYPE_OPTIONS = [
  { label: 'SOAP', name: 'SOAP' },
  { label: 'Finalização do atendimento', name: 'FINISH_ATTENDANCE' },
]
